/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { OvertimePaymentTableService } from "services/overtime-payment-table";

const formatMonth = (value) => String(value || "").replace(/\D/g, "").slice(0, 2).padStart(2, "0");

const renderData = (items, setDataTable) => {
  return items.map((item) => ({
    id: item._id,
    unitNumber: item.unitNumber,
    year: item.year,
    month: formatMonth(item.month),
    totalEmployment: item.totalEmployment || 0,
    totalActualPayment: formatCurrency.format(item.totalActualPayment || 0),
    createdAt: formatDate(item.createdAt),
    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    { Header: "Số", accessor: "unitNumber" },
    { Header: "Năm", accessor: "year" },
    { Header: "Tháng", accessor: "month" },
    { Header: "Số lượng nhân viên", accessor: "totalEmployment" },
    { Header: "Tổng thực thanh toán", accessor: "totalActualPayment" },
    { Header: "Ngày tạo", accessor: "createdAt" },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function OvertimePaymentTable() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({ page: 1, count: 0, size: 10 });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await OvertimePaymentTableService.getPaginate({
        ...query,
        page: paginationData.page,
        limit: paginationData.size,
      });
      const { items, paginate } = response.data || response;

      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));
    } catch (error) {
      setDataTable((prev) => ({ ...prev, rows: [] }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default OvertimePaymentTable;
